// src/app/shared/navbar/navbar.component.ts
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-static-navbar',
  standalone: true,
  imports: [RouterModule],
  template: `
    <nav class="custom-navbar">
      <div class="container">
        <a routerLink="/login" class="brand"><img src='assets/images/logo.png' alt="Hindustan Antibiotics Limited" /></a>
        <ul class="nav-links">
          <li><a routerLink="/login">Home</a></li>
          <li><a routerLink="/about">About</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
          <li><a routerLink="/terms-of-service">Terms</a></li>
        </ul>
      </div>
    </nav>
  `,
  styles: [`
    .custom-navbar {
      background-color: #343a40;
      padding: 0.5rem 0;
    }
    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 1rem;
    }
    .brand {
      color: #fff;
      font-weight: bold;
      font-size: 1.5rem;
      text-decoration: none;
    }
    .nav-links {
      list-style: none;
      display: flex;
      gap: 1.5rem;
      margin: 0;
    }
    .nav-links li a {
      color: white;
      text-decoration: none;
      font-weight: 500;
    }
    .nav-links li a:hover {
      text-decoration: underline;
    }
  `]
})
export class StaticNavbarComponent { }
